module.exports = __WEBPACK_EXTERNAL_MODULE_227__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/switchMap"
// module id = 227
// module chunks = 0